import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.reviewops.data.quality');
import { Input } from '@angular/core';

@Component({
    selector: 'wiz-component-reviewops-data-quality',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.reviewops.data.quality/view.scss */
/* src/app/component.reviewops.data.quality/view.scss: no such file or directory */`],
})
export class ComponentReviewopsDataQualityComponent {
    @Input() dataQuality: any = {};
    @Input() availability: any = {};
    @Input() reliability: any = {};
    @Input() missingData: any = {};
    @Input() peerQuality: any = {};
    @Input() classification: any = {};

    public fields(status: string): any[] {
        return (this.dataQuality.field_details || []).filter((item: any) => item.status === status);
    }

    public recommendations(): any[] {
        return (this.missingData.recommended_additional_data || []).slice(0, 5);
    }

    public tone(value: string): string {
        if (value === 'HIGH' || value === 'AVAILABLE' || value === 'FULL') {
            return 'bg-emerald-100 text-emerald-800';
        }
        if (value === 'MODERATE' || value === 'PARTIAL') {
            return 'bg-amber-100 text-amber-800';
        }
        return 'bg-rose-100 text-rose-800';
    }
}

export default ComponentReviewopsDataQualityComponent;